// extracted by mini-css-extract-plugin
export default {"flexCenter":"NameCell_flexCenter__5ETZs","text":"NameCell_text__MKOLm","clickable":"NameCell_clickable__kXc4q"};